import React from 'react';

export const ActsCol = () => {
    return (
        <div className="row thead">
            <div className="col download-col auto-width">Название акта</div>
            <div className="col period-col">Период</div>
            <div className="col date-col">Дата выставления</div>
            <div className="col lesson-count-col align-right">Количество занятий</div>
            <div className="col students-col align-right">Стоимость занятия</div>
            <div className="col total-sum-col align-right">Сумма</div>
        </div>
    );
};

